import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ViewAltLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 12, cy: 12, r: 3.5, stroke: "currentColor" }),
            React.createElement("path", { stroke: "currentColor", d: "M21 12s-1-8-9-8-9 8-9 8" })));
}
const ViewAltLight = forwardRef(_ViewAltLight);
export { ViewAltLight };
